import React from 'react'
import { differenceInDays, formatDistance, format } from 'date-fns'
import { Popup } from 'lib/ui'

const formatDate = date => {
  const diffDays = differenceInDays(date, new Date())
  if (diffDays > 30) {
    return format(date, 'MMM do, y')
  } else {
    return `${formatDistance(date, new Date())} ago`
  }
}

const DateDisplay = ({
  label = '',
  date,
  ...rest
}: {
  label?: string
  date: Date
} & React.ComponentProps<'span'>) => (
  <span {...rest}>
    {label && <span>{label}:</span>}
    <Popup
      content={
        <span>
          {label && `${label}:`} {format(date, 'MMM do, y @ hh:mm a')}
        </span>
      }
      trigger={
        <span className="[border-bottom:1px_dashed_gray] hover:cursor-help">
          {formatDate(date)}
        </span>
      }
    />
  </span>
)

export default DateDisplay
